import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "upload_body"
};
const _hoisted_2 = {
  class: "upload_body_nr"
};
const _hoisted_3 = {
  class: "upload_list"
};
const _hoisted_4 = {
  key: 0,
  style: {
    "width": "347px"
  },
  src: "https://www.mimodental.com/assets/imgData/img/member_preferential/empty.png"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "time"
};
const _hoisted_7 = {
  class: "remark"
};
const _hoisted_8 = {
  class: "fill"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["src", "onClick"];
const _hoisted_11 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("h1", null, "查看历史记录", -1)), _createElementVNode("div", _hoisted_3, [$setup.upList.length == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", {
      class: "delete_icon",
      onClick: $event => $setup.deleteBenefitActivityRecord(item.id)
    }, " 删除 ", 8, _hoisted_5), _createElementVNode("span", _hoisted_6, _toDisplayString(item.createTime), 1), _createElementVNode("span", _hoisted_7, _toDisplayString(item.remark), 1), _createElementVNode("div", _hoisted_8, [item.imageUrl ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("img", {
      src: item.imageUrl,
      onClick: $event => $setup.look(item.imageUrl),
      alt: ""
    }, null, 8, _hoisted_10)])) : _createCommentVNode("", true), item.videoUrl ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      onClick: $event => $setup.look(item.videoUrl)
    }, _cache[0] || (_cache[0] = [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/imgs/vido_icon.png",
      alt: ""
    }, null, -1), _createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/imgs/bf.png",
      alt: "",
      class: "bf_icon"
    }, null, -1)]), 8, _hoisted_11)) : _createCommentVNode("", true)])]);
  }), 128))])])]);
}